module.exports = __webpack_public_path__ + "static/media/comp2.e0cd494a.png";